<script setup>
import useUser from '@/composables/useUser';
import { onMounted, onUnmounted } from 'vue';
const isStake = useState('isStake', () => false);


const { getAuth } = useUser();
const { apiBaseUrl, fasttrackBrandName, loaderBranch, enableJackpots, enableLoginChallenge, enableChristmasPromo2026, isStarryProd, getCurrentEnvType } = useApi(undefined, useCookie('desired_environment')?.value);

const branch = useCookie('rewards-branch');
const rewardsPr = useCookie('rewards-pr');

const scripts = [];
const appendScript = (script) => {
  scripts.push(script);
  document.body.appendChild(script);
};
let onAuthed;
const onReady = () => window.FasttrackCrm.init(undefined, undefined);
onUnmounted(() => {
  window.removeEventListener('fasttrack-crm-authed', onAuthed);
  window.removeEventListener('fasttrack-crm-ready', onReady);
  for (const script of scripts) {
    script.onload = null;
    script.remove();
  }
});

onMounted(() => {

  window.fasttrackbrand = fasttrackBrandName();

  window.ftRewardsConfig = {
    mock: {
      jackpots: enableJackpots,
      loginChallenge: enableLoginChallenge,
    },
    christmasPromo2026: enableChristmasPromo2026,
  }

  window.ftcrm = {
    ...window.ftcrm,
    name: 'Starry Spins',
    baseApiUrl: apiBaseUrl(),
  };

  onAuthed = function () {
    console.log('fasttrack-crm-authed')
    // Set auth for the rewards SDK before its own fasttrack-crm-authed
    // listener fires (this listener was registered first, so it runs first).
    // By not setting window.ftcrm.auth before scripts load, we prevent
    // the rewards IIFE from auto-initializing, making this the single
    // init path.
    const auth = getAuth();
    if (!window.ftcrm) window.ftcrm = {};
    if (!window.ftcrm.auth) window.ftcrm.auth = {};
    if (auth?.JwtToken) {
      window.ftcrm.auth.jwtToken = auth.JwtToken;
    }
    if (auth?.User?.UserId) {
      window.ftcrm.auth.userId = auth.User.UserId;
    }

    if (window && window.fasttrack && window.fasttrack.enableCrmIntegration && window.fasttrack.enableCrmIntegration === true) {
      window.FasttrackCrm.loggedIn()
        .then(response => console.log(response))
        .catch(error => console.log(error));
    }
  };
  window.addEventListener('fasttrack-crm-authed', onAuthed, { once: true });
  window.addEventListener('fasttrack-crm-ready', onReady, { once: true });

  const isNewIntegration = isStake.value;

  if (isNewIntegration) {
    const cssId = 'fasttrack-crm-css'; // you could encode the css path itself to generate id..
    if (!document.getElementById(cssId)) {
      const head = document.getElementsByTagName('head')[0];
      const link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = 'https://crm-lib-staging.fasttrack-solutions.com/lib/css/fasttrack-crm-app.css?v=6a0df6742bfc4b4701dab9dd3f96260ee5383b92';
      link.media = 'all';
      head.appendChild(link);

      window.fasttrackVersion = 'local';
    }


    const existingDiv = document.getElementById('fasttrack-crm');

    if (!existingDiv) {
      const appDiv = document.createElement('div');
      appDiv.id = 'fasttrack-crm';

      document.body.appendChild(appDiv);
    }

    const scriptVendor = document.createElement('script');
    scriptVendor.async = true;
    scriptVendor.src = 'https://crm-lib-staging.fasttrack-solutions.com/lib/js/fasttrack-crm-chunk-vendors.js?v=6a0df6742bfc4b4701dab9dd3f96260ee5383b92';
    scriptVendor.onload = function () { /* eslint-disable-line */
      console.log('Fasttrack CRM: Vendor JS loaded');
      const scriptMain = document.createElement('script');
      scriptMain.async = true;
      scriptMain.onload = function () { /* eslint-disable-line */
        console.log('Fasttrack CRM: Main script loaded');
      };
      scriptMain.src = 'https://crm-lib-staging.fasttrack-solutions.com/lib/js/fasttrack-crm-app.js?v=6a0df6742bfc4b4701dab9dd3f96260ee5383b92';

      appendScript(scriptMain);
    };

    appendScript(scriptVendor);

    const crmScript = document.createElement('script');
    crmScript.src = `/rewards-main.umd.js`;
    crmScript.async = true;
    appendScript(crmScript);

  } else {

    var fastTrackCrmScript = document.createElement('script');
    fastTrackCrmScript.async = true;
    fastTrackCrmScript.onload = function () {
      new window.FastTrackLoader();
    };

    const base = (isStarryProd() || getCurrentEnvType() === 'Production' || branch.value === 'production') ? 'crm-lib' : 'crm-lib-staging'

    var fastTrackCrmScriptSrc = `https://${base}.fasttrack-solutions.com/${loaderBranch()}/fasttrack-crm.js?v=${new Date().getTime()}${branch.value === 'feature' ? `&rewards=${encodeURIComponent(rewardsPr.value)}` : ''}`;
    fastTrackCrmScript.src = fastTrackCrmScriptSrc;
    appendScript(fastTrackCrmScript);
  }
});
</script>

<template></template>